export default __webpack_public_path__ + "static/media/icon-default-profile.96e9d018.svg";